var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnionCorners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=UnionCorners, colour=NeutralDefault, htmlTag=img, assetKey=Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Content",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3958 6.07943H6.72917C5.99279 6.07943 5.39583 6.67638 5.39583 7.41276V18.0794C5.39583 18.8158 5.99279 19.4128 6.72917 19.4128H17.3958C18.1322 19.4128 18.7292 18.8158 18.7292 18.0794V7.41276C18.7292 6.67638 18.1322 6.07943 17.3958 6.07943ZM6.72917 4.74609C5.25641 4.74609 4.0625 5.94 4.0625 7.41276V18.0794C4.0625 19.5522 5.25641 20.7461 6.72917 20.7461H17.3958C18.8686 20.7461 20.0625 19.5522 20.0625 18.0794V7.41276C20.0625 5.94 18.8686 4.74609 17.3958 4.74609H6.72917Z",
    fill: "#878D9B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionCorners);
export default __webpack_public_path__ + "static/media/UnionCorners.655ced509d61e81dacbdd37074fb6c57.svg";
export { ForwardRef as ReactComponent };